<template>
  <div v-if="isOpen" class="modal" @click.self="handleOverlayClick">
    <div class="modal__wrapper">
      <div @click="closeModal" class="modal__close-wrapper">
        <button v-if="showClose" class="modal__close-btn">
          <img :src="closeIcon" />
        </button>
      </div>
      <div class="modal__content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
const { cdn } = config
export default {
  props: {
    isOpen: {
      required: true
    },
    showClose: {
      type: Boolean
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      closeIcon: `${cdn}icons-x-close-hide.svg`
    }
  },
  methods: {
    closeModal () {
      this.$emit('close-modal')
    },
    handleOverlayClick () {
      if (this.closeOnOverlayClick) {
        this.closeModal()
      }
    }
  }
}
</script>
